<template>
 <div>
 
  <div style="max-width:450px;margin: auto;">
    <div class="row" style="">
      <div class="" @click="prevWeek" style="width:14%;text-align:center"><i class="ion-arrow-left-b"></i></div>
      <div class="titleDate" style="width:72%;" @click="showCalendar">{{this.weekRecord.Descr}} <i class="ion-calendar"></i></div>
      <div class="" @click="nextWeek" style="width:14%;text-align:center;"><i class="ion-arrow-right-b"></i></div>
    </div>
    <transition name="slide">
    <div class="row" v-show="weekChangeClicked"  style="margin-top:10px;margin-left:15px">
        <div style="width:14%"><date-item :record="this.weekRecord.Mon" @dat-select-event="selectDatEvt" class="calenderitem"></date-item></div>
        <div style="width:14%"><date-item :record="this.weekRecord.Tue" @dat-select-event="selectDatEvt" class="calenderitem"></date-item></div>
        <div style="width:14%"><date-item :record="this.weekRecord.Wed" @dat-select-event="selectDatEvt" class="calenderitem"></date-item></div>
        <div style="width:14%"><date-item :record="this.weekRecord.Thu" @dat-select-event="selectDatEvt" class="calenderitem"></date-item></div>
        <div style="width:14%"><date-item :record="this.weekRecord.Fri" @dat-select-event="selectDatEvt" class="calenderitem"></date-item></div>
        <div style="width:14%"><date-item :record="this.weekRecord.Sat" @dat-select-event="selectDatEvt" class="calenderitem"></date-item></div>
        <div style="width:14%"><date-item :record="this.weekRecord.Sun" @dat-select-event="selectDatEvt" class="calenderitem"></date-item></div>
    </div>
    </transition>
  </div>
  <div class="row" v-if="isHideCal" style="text-align: center;">
     <div class="col-12">
         <v-calendar :attributes="attrs" :min-date="new Date()" @dayclick="dayClicked" v-model="myDate" mode="single"></v-calendar>
      </div>
  </div>
  <div class="row" v-if="freePaces.IsNextFreeApp">
     <div  class="col-24" style="margin-top:4px;margin-bottom:5px;text-align:center">
          <span style="color:#ff0000;">{{freePaces.NextFreePlaceMsg}}</span>
      </div>
      <div  class="col-24">
          <div class="product-btn" style="text-align:center;margin-top:10px">
          <a  @click="loadNextFreePlace" v-bind:style="{ 'background-color': getColorApp}" style="color:#fff"><i class="ion-calendar" ></i>Zoek naar volgende vrije plaats</a>
          </div>
      </div>
  </div>
  <div class="row" v-if="!isHideCal">
      <div class="col-24" v-if="!isNoFreePlace">
         <cart-free-place :record="freePaces"></cart-free-place>
      </div>
      <div  class="col-24" v-else>
          <br>
          <h5>Geen tijden beschikbaar</h5>
      </div>
  </div>

 </div>
</template>

<style>
.slide-leave-active,
.slide-enter-active {
  transition: 1s;
}
.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(-100%, 0);
}

.titleDate
{
  font-size: 15px;
  font-weight: bold;
  text-align:center;
}

.calendarpopup {
   position:fixed;
    top: 50%;
  
}
.calenderitem {
  border-radius: 5px;
  border-width: 1px;
  width:38px;
  border-style: solid;
}

</style>

<script>
import Vue from 'vue';
import VCalendar from 'v-calendar';
import 'v-calendar/lib/v-calendar.min.css';
import myHttpApi from "../../api/myhttpapi";
import CartDateItem from "./CartDateItem";
import CartFreePlace from "./CartFreePlace";
import {
    SPINNER_SHOW,
    SPINNER_HIDE
  } from '../../store/mutation-types'

  export default {
    data () {
      return {
        cart: this.$store.state.cart,
        isHideCal : false,
        weekChangeClicked : true,
        datWeek : '',
        weekRecord : [],
        freePaces : {},
        myDate: new Date(),
        isNoFreePlace : false,
        isShowNextFreeDate : false,
        blockNavToStartOfWeek : false,
        isWeekBack : false,
        dateNextStr : '',
        attrs: [
        {
          key: 'today',
          dates: new Date()
        }
      ],
      }
    },
    components: {
        //vcalendar: VCalendar,
        dateItem : CartDateItem,
        cartFreePlace : CartFreePlace
    },
    mounted () {

      if (Vue.$selectedStore !== undefined) return;

      this.datWeek = new Date ();
      this.myDate = this.datWeek;
      this.blockNavToStartOfWeek = true;
      this.loadWeekCal ();
      //this.attrs.highlight.backgroundColor = Vue.$storeSettings.ColorApp;
    },
    computed: {
      getColorApp () {
           return Vue.$storeSettings.ColorApp;
       },
       getUserSelectAllowed () {
           return Vue.$storeSettings.IsHideUsers;
       }
    },
    methods: {
      nextWeek () {
        this.isWeekBack = false;
        this.blockNavToStartOfWeek = false;
        this.isHideCal = false;
        this.datWeek.setDate (this.datWeek.getDate() + 7);
        this.loadWeekCal ();
      },
      prevWeek () {
        this.isWeekBack = true;
        this.blockNavToStartOfWeek = false;
        this.isHideCal = false;
        this.datWeek.setDate (this.datWeek.getDate() - 7);
        this.loadWeekCal ();
      },
      selectDatEvt (evt) {
        this.isWeekBack = false;
        this.isHideCal = false;
        var dtStr = evt.DateStr;
        this.myDate = new Date (evt.Year, evt.Month - 1, evt.Day, 23,59,0);
        this.datWeek = this.myDate;
        
        //console.log (evt);
        if (evt.StatusID == 1)
        {
            this.isNoFreePlace = true;
            return; //Geen plaats vrij.. geen uren gekend..
        }

        this.hideUnselectedDates (dtStr, false);

        if (this.myDate < new Date())
        {
            this.isNoFreePlace = true;
        }
        else
        {
            this.isNoFreePlace = false;
            this.loadFreePlaces ();
        }
        

        
      },
      hideUnselectedDates (dtStr, flgReset) {

        if (flgReset)
        {
           this.weekRecord.Mon.IsSelected = true;
           this.weekRecord.Tue.IsSelected = true;
           this.weekRecord.Wed.IsSelected = true;
           this.weekRecord.Thu.IsSelected = true;
           this.weekRecord.Fri.IsSelected = true;
           this.weekRecord.Sat.IsSelected = true;
           this.weekRecord.Sun.IsSelected = true;
        }

        if (dtStr != this.weekRecord.Mon.DateStr) this.weekRecord.Mon.IsSelected = false;
        if (dtStr != this.weekRecord.Tue.DateStr) this.weekRecord.Tue.IsSelected = false;
        if (dtStr != this.weekRecord.Wed.DateStr) this.weekRecord.Wed.IsSelected = false;
        if (dtStr != this.weekRecord.Thu.DateStr) this.weekRecord.Thu.IsSelected = false;
        if (dtStr != this.weekRecord.Fri.DateStr) this.weekRecord.Fri.IsSelected = false;
        if (dtStr != this.weekRecord.Sat.DateStr) this.weekRecord.Sat.IsSelected = false;
        if (dtStr != this.weekRecord.Sun.DateStr) this.weekRecord.Sun.IsSelected = false;
      },
      showCalendar () {
        this.isHideCal = ! this.isHideCal;
      },
      dayClicked (day) {
          this.isHideCal = false;
          this.datWeek = day.date;
          this.myDate = day;
          this.blockNavToStartOfWeek = true;
          this.loadWeekCal ();
      },
      loadWeekCal () {
        
          const searchRec = {Year: this.datWeek.getFullYear() , Month: (this.datWeek.getMonth() + 1) , Day: this.datWeek.getDate() }
          myHttpApi.post( 'Service/GetDaysWeek', searchRec)
              .then(response => {
                this.weekChangeClicked = false;
                this.weekRecord = response.data;
                
                if (!this.blockNavToStartOfWeek)
                {
                    this.myDate = new Date (this.weekRecord.FromYear, this.weekRecord.FromMonth - 1, this.weekRecord.FromDay, 23,59,0);
                    this.datWeek = this.myDate;
                }
                this.blockNavToStartOfWeek = false;
                

                this.loadFreePlaces ();
                this.weekChangeClicked = true;
              })
              .catch(error => {
                console.log(error);
                this.weekChangeClicked = true;
          });
      },
      loadNextFreePlace () {
          this.isShowNextFreeDate = true;
          this.hideUnselectedDates (this.dateNextStr, true);
          this.loadFreePlaces ();
      },
      loadFreePlaces () {
          this.$store.commit(SPINNER_SHOW);
          const searchRec = {Year: this.datWeek.getFullYear() , Month: (this.datWeek.getMonth() + 1) , Day: this.datWeek.getDate(), BasketItems: this.cart, SearchNext : this.isShowNextFreeDate, BackButton : this.isWeekBack }
          console.log (searchRec);

          this.isShowNextFreeDate = false;
          myHttpApi.post( 'Basket/GetFreePlaces', searchRec)
              .then(response => {
                 this.freePaces = response.data;
                 this.isNoFreePlace = false; 

                 if (this.freePaces.Records.length <= 0) {this.isNoFreePlace = true;}
                 if (this.freePaces.IsNextFreeApp)
                 {
                   this.dateNextStr = this.freePaces.DateStr;

                   this.myDate = new Date (this.freePaces.Year, this.freePaces.Month - 1, this.freePaces.Day, 23,59,0);
                   this.datWeek = this.myDate;

                   this.datWeek.setDate (this.datWeek.getDate() + 1);
                   this.weekRecord = this.freePaces.NextWeekDays
                   this.weekChangeClicked = true;
                 }
                 this.$store.commit(SPINNER_HIDE);
              })
              .catch(error => {
                console.log(error);
                this.freePaces = [];
                this.$store.commit(SPINNER_HIDE);
          });
      }

    }
  }

 Vue.use(VCalendar, {
        firstDayOfWeek: 2
    });
 
</script>


// WEBPACK FOOTER //
// src/components/cart/CartDate.vue